export function unsafeEncrypt(s) {
  if (s) {
    try {
      return btoa(s);
    } catch (err) {}
  }
  return s;
}

export function unsafeDecrypt(s) {
  if (s) {
    try {
      return atob(s);
    } catch (err) {}
  }
  return s;
}
